import { PlayerRef } from '@remotion/player';
import React from 'react';
import {
  FEATURE_LINKING,
  FEATURE_SKIMMING,
  FEATURE_SPLIT_ITEM,
  FEATURE_TIMELINE_SNAPPING,
  FEATURE_TIMELINE_ZOOM_SLIDER,
} from '../flags';
import { LinkingToggle } from '../action-row/linking-toggle';
import { SkimmingToggle } from '../action-row/skimming-toggle';
import { SnappingToggle } from '../action-row/snapping-toggle';
import { SplitItemTool } from '../action-row/split-item-tool';
import { DuplicateItemTool } from '../action-row/duplicate-item-tool';
import { DeleteItemTool } from '../action-row/delete-item-tool';
import { FitTimelineButton } from '../action-row/fit-timeline-button';
import { TimelineCollapseToggle } from '../action-row/timeline-collapse-toggle';
import { TimelineZoomSlider } from '../timeline/timeline-zoom-slider';
import EditorHeaderUndoButton from '../header/EditorHeaderUndoButton';
import EditorHeaderRedoButton from '../header/EditorHeaderRedoButton';
import { EditTools } from './edit-tools';

function ToolbarDivider() {
  return <div className="h-3 w-px shrink-0 bg-sys-style-neutral-default" />;
}

export const TimelineToolbar: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({ playerRef }) => {
  return (
    <div className="relative flex h-10 w-full shrink-0 items-center justify-between border-t border-t-sys-style-neutral-default bg-sys-bg-surface-1 px-md py-2xs">
      {/* 좌측: 편집도구 | Undo/Redo | Split/Duplicate/Delete */}
      <div className="flex min-h-px min-w-px flex-1 items-center gap-2xs">
        <div className="flex shrink-0 items-center">
          <EditTools />
        </div>

        <ToolbarDivider />

        <div className="flex shrink-0 items-center">
          <EditorHeaderUndoButton />
          <EditorHeaderRedoButton />
        </div>

        <ToolbarDivider />

        <div className="flex shrink-0 items-center">
          {FEATURE_SPLIT_ITEM && <SplitItemTool playerRef={playerRef} />}
          <DuplicateItemTool />
          <DeleteItemTool />
        </div>
      </div>

      {/* 우측: 타임라인옵션 | 타임라인줌 + Fit */}
      <div className="flex min-h-px min-w-px flex-1 items-center justify-end gap-2xs">
        <div className="flex shrink-0 items-center gap-4xs">
          {FEATURE_SKIMMING && <SkimmingToggle />}
          {FEATURE_LINKING && <LinkingToggle />}
          {FEATURE_TIMELINE_SNAPPING && <SnappingToggle />}
        </div>

        {FEATURE_TIMELINE_ZOOM_SLIDER && (
          <>
            <ToolbarDivider />
            <div className="flex shrink-0 items-center gap-2xs">
              <TimelineZoomSlider />
              <FitTimelineButton />
            </div>
          </>
        )}

        <ToolbarDivider />
        <TimelineCollapseToggle />
      </div>
    </div>
  );
};
